import React from 'react';
import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton, Typography, makeStyles, createStyles, Slide } from '@material-ui/core';
import cn from 'classnames';
import { CloseRounded as CloseIcon } from '@material-ui/icons';
import { TransitionProps } from '@material-ui/core/transitions';
import { TranquiTheme } from '../../containers/App/theme';

type ModalProps = Omit<DialogProps, 'OnClose'> & {
  children: any;
  onClose: () => void;
  title?: string;
  className?: string;
  classNameTitleBox?: string;
  fullWidth?: boolean;
  showCloseBtn?: boolean;
};

const Transition = React.forwardRef((
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) => {
  return (
    <Slide
      direction="up"
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
});

const Modal:React.FC<ModalProps> = (props) => {
  const {
    className, classNameTitleBox, title,
    fullWidth, onClose, children, showCloseBtn, ...others
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  return (
    <Dialog
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...others}
      fullWidth={fullWidth}
      onClose={onClose}
      classes={{
        paper: classes.root,
      }}
      className={cn(classes.root, className)}
      BackdropProps={{ classes: { root: classes.backdrop } }}
      TransitionComponent={Transition}
    >
      {showCloseBtn
        && (
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        )}
      {title
        && (
        <DialogTitle disableTypography className={cn(classes.titleBox, classNameTitleBox)}>
          <Typography className={classes.title}>{title}</Typography>
        </DialogTitle>
        )}
      <DialogContent>
        { children }
      </DialogContent>

    </Dialog>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    padding: theme.spacing(2, 0, 4, 0),
    boxShadow: theme.shadows[5],
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    ...theme.typography.h3,
    color: theme.palette.indigo.main,
    fontSize: '1.3rem',
  },
  closeButton: {
    position: 'absolute',
    top: `${theme.spacing(0.5)}px`,
    right: `${theme.spacing(0.5)}px`,
  },
  backdrop: {
    backdropFilter: 'blur(3px)',
    backgroundColor: `${theme.palette.text4.main}50`,
  },
}));

export default Modal;
